export default {
    init() {
      window.partnerPage = 0;
      window.postPerPage = 25;
      this.loadFirstResourcesFromAPI();
      this.loadResourcesFromAPI();
      this.clearFilters();
    },
    loadFirstResourcesFromAPI() {
      if (window.partnerPage === 0) { 
        const that = this;
        const url = $('#partners-results-first').attr('data-url');
        const start_time = new Date().getTime();
        window.firstRequest = $.ajax({
          url: $('#partners-results-first').attr('data-url'),
          method: 'GET',
        }).done(function (data) {
          console.log(url, ' Request took ', new Date().getTime() - start_time, 'ms');
          window.partners = data;
          that.performPartnersSearch();
          that.addEventPartners();
        });
      }
    },
    loadResourcesFromAPI() {
      const that = this;
      const url = $('#partners-results-all').attr('data-url');
      const start_time = new Date().getTime();
  
      $.ajax({
        url: url,
        method: 'GET',
      }).done(function (data) {
        window.firstRequest.abort();
        console.log(url, ' Request took ', new Date().getTime() - start_time, 'ms');
  
        window.partners = data;
        that.performPartnersSearch();
        that.addEventPartners();
        $('.loader').hide();
      });
    },
    performPartnersSearch() {
      const partnerName = $('#filter__partner-name').val();
      const country = $('#filter__country').val();
      
      // DO NOT REMOVE
      // const language = $('#filter__language').val();
      // const service = $('#filter__service').val();
      // const product = $('#filter__product').val();
      // const sponsorLevel = $('#filter__sponsor-level').val();
  
      window.foundPartners = [];
      window.partners.forEach(function (partner) {
        let failedChecks = 0
  
        // Name
        if (partnerName !== '' && partner.title.toLowerCase().indexOf(partnerName.toLowerCase()) === -1) {
          failedChecks++;
        }
  
        // Country
        if (country) {
          let hasCountry = false;
          partner.countries.forEach((c) => {
            if (c === country) {
              hasCountry = true;
            }
          });
  
          if (hasCountry === false) {
            failedChecks++;
          }
        }
        
        // Language - DO NOT REMOVE
        // if (language && partner.languages) {
        //   let hasLanguage = false;
  
        //   partner.languages.forEach((l) => {
        //     if (l === language) {
        //       hasLanguage = true;
        //     }
        //   });
  
        //   if (hasLanguage === false) {
        //     failedChecks++;
        //   }
        // }
  
        // if (language && !partner.languages) {
        //   failedChecks++;
        // }
  
        // Sponsor level - DO NOT REMOVE
        // if (sponsorLevel && sponsorLevel !== partner.sponsorLevel) {
        //   failedChecks++;
        // }
  
        // Service - DO NOT REMOVE
        // if (service && partner.services) {
        //   let hasService = false;
  
        //   partner.services.forEach((s) => {
        //     if (s === service) {
        //       hasService = true;
        //     }
        //   });
  
        //   if (hasService === false) {
        //     failedChecks++;
        //   }
        // }
  
        // if (service && !partner.services) {
        //   failedChecks++;
        // }
  
        // Product - DO NOT REMOVE
        // if (product && partner.products) {
        //   let hasProduct = false;
  
        //   partner.products.forEach((p) => {
        //     if (p === product) {
        //       hasProduct = true;
        //     }
        //   });
  
        //   if (hasProduct === false) {
        //     failedChecks++;
        //   }
        // }
  
        // if (product && !partner.products) {
        //   failedChecks++;
        // }
  
        // Pass
        if (failedChecks === 0) {
          window.foundPartners.push(partner)
        }
      });
  
      this.renderPartners();
    },
    partnerTemplate(partner) {
      return `
        <div class="partner border-bottom pb-14 mb-14">
          <h2 class="text-primary text-04 overflow-hidden ${partner.excerpt ? 'mb-2' : 'mb-12'}">
            <span class="mr-3 float-left d-inine-block">${partner.title}</span>
            ${partner.sponsorLevel !== null || partner.badge !== null ? `
              <div class="float-left overflow-hidden">
                ${partner.sponsorLevel !== null ?
                  `<span class="tag d-inine-block float-left ${partner.badge ? 'mr-3' : ''}">${partner.sponsorLevel}</span>` : ''
                }
                ${partner.badge !== null ?
                  `<span class="tag d-inine-block float-left">${partner.badge}</span>` : ''
                }
              </div>
            ` : ''}
          </h2>
          ${partner.excerpt !== null ?
            `<p class="mb-12">${partner.excerpt}</p>` : ''
          }
          <div class="d-flex flex-wrap">
            <div class="partner__info mb-12">
              <div class="px-3 border-left border-primary">
                <h6 class="text-07 text-primary mb-1">Countries</h6>
                <div class="partner__info__more">
                  ${partner.countries.map(country => {
                    return '<div>' + country + '</div>'
                  }).join('')}
                </div>
                ${partner.countries.length + 1 > 8 ? '<a class="partner__info__more__action" href="#">show more +</a>' : ''} 
              </div>
            </div>
            ${partner.languages !== null ?
              `<div class="partner__info mb-12">
                <div class="px-3 border-left border-primary">
                  <h6 class="text-07 text-primary mb-1">Languages</h6>` + 
                  partner.languages.map(language => {
                    return '<div>' + language + '</div>'
                  }).join('') +
                `</div>
              </div>` : ''}
            ${partner.products !== null ?
              `<div class="partner__info mb-12">
                <div class="px-3 border-left border-primary">
                  <h6 class="text-07 text-primary mb-1">Products</h6>` + 
                  partner.products.map(product => {
                    return '<div>' + product + '</div>'
                  }).join('') +
                `</div>
              </div>` : ''}
            ${partner.services !== null ?
              `<div class="partner__info mb-12">
                <div class="px-3 border-left border-primary">
                  <h6 class="text-07 text-primary mb-1">Services</h6>` + 
                  partner.services.map(service => {
                    return '<div>' + service + '</div>'
                  }).join('') +
                `</div>
              </div>` : ''}
          </div>
          <div class="cta cta-black-border">
            <a id="filter__clear" href="${partner.url}" class="no-deco">More</a>
          </div>
        </div>
      `;
    },
    renderPartners() {
      const that = this;
      let foundPartners = window.foundPartners;
      let html = '';
  
      foundPartners = foundPartners.slice(window.partnerPage * window.postPerPage, (window.partnerPage * window.postPerPage) + window.postPerPage);
      foundPartners.forEach(function (partner) {
        html += that.partnerTemplate({
          title: partner.title,
          badge: partner.badge,
          sponsorLevel: partner.sponsorLevel,
          countries: partner.countries,
          languages: partner.languages,
          services: partner.services,
          products: partner.products,
          excerpt: partner.excerpt,
          url: partner.url,
        });
      });
  
      html += that.getPagination();
  
      $('#partners').html(html)
  
      if (foundPartners.length === 0) {
        $('#no-results').show()
      } else {
        $('#no-results').hide()
      }
  
      that.handlePagination();
      that.partnerInfoMore();
    },
    partnerInfoMore() {
      $('.partner__info__more__action').on('click', function (e) {
        e.preventDefault();
        $(this).hide().siblings('.partner__info__more').css('max-height', 'unset');
      });
    },
    pagination(c, m) {
      let current = c,
      last = m,
      delta = 2,
      left = current - delta,
      right = current + delta + 1,
      range = [],
      rangeWithDots = [],
      l;
  
      for (let i = 1; i <= last; i++) {
        if (i == 1 || i == last || i >= left && i < right) {
          range.push(i);
        }
      }
  
      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
          }
        }
        rangeWithDots.push(i);
        l = i;
      }
  
      return rangeWithDots;
    },
    getPagination() {
      let pagination = '<div class="container"><div class="nav-links-resource flex text-center mb-12">';
      const totalPartners = window.foundPartners.length
      // eslint-disable-next-line no-unused-vars
      let numberOfPages = Math.floor(totalPartners / window.postPerPage);
      numberOfPages = (totalPartners > (window.postPerPage * numberOfPages)) ? numberOfPages + 1 : numberOfPages;
      
      if (numberOfPages === 1) {
        return '';
      }
  
      numberOfPages = this.pagination(window.partnerPage, numberOfPages);
  
      for (let x = 0; x < numberOfPages.length; x++) {
        let addclass = (parseInt(numberOfPages[x]) - 1 == window.partnerPage) ? ' color-primary' : ''
        addclass += (numberOfPages[x] == '...') ? ' no-event' : ' cursor-pointer'
        pagination += '<span class="page-number block mx-2 ' + addclass + '">' + numberOfPages[x] + '</span>'
      }
  
      pagination += '</div></div>';
      return pagination;
    },
    handlePagination() {
      const that = this;
      $('.page-number:not(.no-event)').click(function () {
        window.partnerPage = parseInt($(this).html()) - 1
        that.renderPartners();
        $([document.documentElement, document.body]).animate({
          scrollTop: $('#partners').offset().top - 200,
        }, 700);
      })
    },
    addEventPartners() {
      const that = this;
  
      $('#filter select').on('change', function () {
        window.partnerPage = 0;
        that.performPartnersSearch();
        
      });
  
      let timer = 0
      $('#filter input').on('keyup', function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
          window.partnerPage = 0;
          that.performPartnersSearch();
        }, 200);
      });
    },
    clearFilters() {
      const that = this;
      $('.filter__clear').on('click', function (e) {
        e.preventDefault();
        $('#filter select').val('');
        $('#filter input').val('');
        that.performPartnersSearch();
      });
    },
    finalize() {
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/templatePartnerLocator.js